import { AvField, AvForm } from "availity-reactstrap-validation";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import userImg from "../../../assets/user1.svg";
import BaseService from "../../../services/BaseService";
import Loader from "../../../common/Loader";
import UserService from "../../../services/UserService";
import { toast } from "react-toastify";
import {
	updateAvatarAction,
	updateDataAction,
} from "../../../store/actions/AuthActions";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";

const UpdateAccount = ({ title }) => {
	const { t } = useTranslation();
	const [formData, setFormData] = useState({
		avatar: "",
		username: "",
		email: "",
		phone: "",
	});
	const userService = new UserService();
	const [pageLoading, setPageLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		setPageLoading(true);
		userService
			.profile()
			.then((res) => {
				if (res?.status === 200) {
					let data = {
						avatar: res?.data?.data?.avatar,
						username: res?.data?.data?.username,
						email: res?.data?.data?.email,
						phone: res?.data?.data?.phone,
					};
					setFormData(data);
				}
				setPageLoading(false);
			})
			.catch(() => setPageLoading(false));
	}, []);

	const changeProfile = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);
		if (filesData?.length === 0) {
			return;
		}
		setLoading(true);
		new BaseService()
			.postUpload(filesData[0])
			.then((res) => {
				if (res?.status === 200) {
					let data = {
						avatar: res.data.url,
					};
					userService
						.updateImageProfile(data)
						.then((res2) => {
							if (res2.status === 200) {
								setFormData({ ...formData, avatar: res.data.url });
								toast.success("Profile Image Updated Successfully.");
								dispatch(updateAvatarAction(data));
							}
							setLoading(false);
						})
						.catch(() => setLoading(false));
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	const submit = () => {
		let data = {
			email: formData.email,
			username: formData.username,
			phone: formData.phone,
		};
		setSubmitLoading(true);
		userService
			.update(data)
			.then((res) => {
				if (res?.status === 200) {
					toast.success("Profile Data Updated Successfully.");
					dispatch(updateDataAction(data));
				}
				setSubmitLoading(false);
			})
			.catch(() => setSubmitLoading(false));
	};

	if (pageLoading) {
		return (
			<div style={{ width: "max-content", margin: "auto", marginTop: "7rem" }}>
				<Loader />
			</div>
		);
	}
	return (
		<>
			<div className="details profile-pic mb-4">
				<p className="tab-title fw-bold">{t("Profile Image")}</p>
				<div className="image-placeholder">
					<div className="avatar-edit">
						<input
							type="file"
							onChange={(e) => changeProfile(e)}
							id={`imageUpload`}
						/>
					</div>
					<div className="avatar-preview">
						{!!formData.avatar ? (
							<div>
								<img
									src={formData?.avatar}
									alt="icon"
									style={{ width: "110px", height: "110px" }}
								/>
							</div>
						) : (
							<>
								{loading && (
									<div className="w-50 m-auto h-50">
										<Loader />
									</div>
								)}
								{!loading && (
									<img
										src={userImg}
										alt="icon"
										style={{ width: "110px", height: "110px" }}
									/>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<AvForm className=" details form-horizontal" onValidSubmit={submit}>
				<p className="tab-title fw-bold">{t(title)}</p>
				<Row>
					<Col md={6} className="col-lg-6 col-md-12 col-12">
						<AvField
							label={t("Name")}
							type="text"
							placeholder={t("Name")}
							bsSize="lg"
							name="username"
							validate={{
								required: {
									value: true,
									errorMessage: `${t("This Field is required")}`,
								},
							}}
							value={formData.username}
							onChange={(e) =>
								setFormData({ ...formData, username: e.target.value })
							}
						/>
					</Col>
					<Col md={6}></Col>
					<Col md={6} className="col-lg-6 col-md-12 col-12">
						<AvField
							label={t("Email")}
							type="email"
							placeholder={t("Email")}
							bsSize="lg"
							name="email"
							validate={{
								required: {
									value: true,
									errorMessage: `${t("This Field is required")}`,
								},
							}}
							value={formData.email}
							onChange={(e) =>
								setFormData({ ...formData, email: e.target.value })
							}
						/>
					</Col>
					<Col md={6}></Col>
					<Col md={6} className="col-lg-6 col-md-12 col-12">
						<label>{t("Phone")}</label>
						<PhoneInput
							country={"kw"}
							enableSearch={true}
							value={formData?.phone}
							onChange={(e) =>
								setFormData((prev) => ({
									...prev,
									phone: e,
								}))
							}
						/>
					</Col>
					<Col md={6}></Col>
					<Col md={6}>
						<Button
							variant="primary"
							className="mt-3 fw-bold w-100"
							type="submit"
							disabled={submitLoading}>
							{t("Save")}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</>
	);
};
export default UpdateAccount;
